import React from 'react';
import { Play, ThumbsUp, Bell } from 'lucide-react';
import SEO from '../components/SEO';
import YouTubeSidebar from '../components/sidebars/YouTubeSidebar';
import { Button } from '../components/ui/button';

const YouTube: React.FC = () => {
  const videos = [
    {
      id: 'dQw4w9WgXcQ',
      title: 'Complete Blogger Tutorial 2025 - From Setup to Monetization',
      views: '250K',
      date: '2 weeks ago',
    },
    {
      id: 'dQw4w9WgXcQ',
      title: 'WordPress Theme Development - Full Course for Beginners',
      views: '180K',
      date: '1 month ago',
    },
    {
      id: 'dQw4w9WgXcQ',
      title: 'SEO Secrets That Actually Work in 2025',
      views: '320K',
      date: '3 weeks ago',
    },
    {
      id: 'dQw4w9WgXcQ',
      title: 'Build a Professional Website in 30 Minutes',
      views: '150K',
      date: '1 week ago',
    },
    {
      id: 'dQw4w9WgXcQ',
      title: 'Monetize Your Blog: 10 Proven Strategies',
      views: '280K',
      date: '2 months ago',
    },
    {
      id: 'dQw4w9WgXcQ',
      title: 'Web Design Trends You Need to Know',
      views: '95K',
      date: '3 days ago',
    },
  ];

  return (
    <>
      <SEO
        title="YouTube Channel"
        description="Free web development tutorials, tips, and courses on our YouTube channel. Subscribe for weekly content."
      />

      <div className="bg-gradient-to-br from-red-50 via-white to-pink-50 py-20">
        <div className="container mx-auto px-4 text-center">
          <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <Play className="w-10 h-10 text-white ml-1" />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            TheCodeBazaar YouTube
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Free tutorials, tips, and courses to help you master web development and design
          </p>
          <a
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300">
              <Bell className="mr-2 w-5 h-5" />
              Subscribe Now
            </Button>
          </a>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="grid lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <YouTubeSidebar />
          </div>

          <div className="lg:col-span-3">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Latest Videos</h2>
              <p className="text-gray-600">Watch our newest tutorials and guides</p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              {videos.map((video, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl overflow-hidden border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300 group cursor-pointer"
                >
                  <div className="relative">
                    <div className="aspect-video bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
                      <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <Play className="w-8 h-8 text-white ml-1" />
                      </div>
                    </div>
                    <div className="absolute bottom-2 right-2 px-2 py-1 bg-black/80 text-white text-xs rounded">
                      15:42
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="font-semibold text-gray-900 mb-2 line-clamp-2 group-hover:text-red-600 transition-colors">
                      {video.title}
                    </h3>
                    <div className="flex items-center space-x-4 text-sm text-gray-500">
                      <div className="flex items-center space-x-1">
                        <ThumbsUp className="w-4 h-4" />
                        <span>{video.views} views</span>
                      </div>
                      <span>{video.date}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Channel Embed */}
            <div className="mt-12 bg-white rounded-2xl p-8 border border-gray-200 shadow-sm">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">Featured Playlist</h2>
              <div className="aspect-video rounded-xl overflow-hidden">
                <iframe
                  src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                  title="Featured Video"
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default YouTube;